module.exports = __webpack_public_path__ + "static/media/19ESCAP45.e689b88c.jpg";